
const NotFoundPage = () => {
    return <div> Sorry, the page you are looking for was not found</div>;
};

export default NotFoundPage;
